import ObjectId from 'bson-objectid';
import React from 'react';
import flatten from 'lodash/flatten';
import cloneDeep from 'lodash/cloneDeep';
import Icon from '../../../../helper/Icon';

NodeList.prototype.remove = HTMLCollection.prototype.remove = () => {
  for (let i = this.length - 1; i >= 0; i--) {
    if (this[i] && this[i].parentElement) {
      this[i].parentElement.removeChild(this[i]);
    }
  }
};

const getObjSize = (object) => {
  let size = 0;
  for (const key of Object.keys(object)) {
    if (object.hasOwnProperty(key)) size++;
  }
  return size;
};

module.exports = {
  isPropertyThere: (object, key) => Object.prototype.hasOwnProperty.call(object, key),
  getNewObjectId: ObjectId.generate,
  getObjectSize: getObjSize,
  getDefaultOptionsForEditableTextView: () => ({
    toolbar: {
      buttons: [
        'bold',
        'italic',
        'superscript',
        'subscript',
        { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
        { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
        { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
        { name: 'anchor', contentDefault: '<i class="icon-link"></i>' },
        'unorderedlist',
        'orderedlist'
      ]
    }
  }),
  isDefined: item => item !== null && item !== undefined,
  intersperse: (arr, inter) => flatten(arr.map((a, i) => (i ? [inter, a] : [a]))),
  getNumberOfWords: (para) => {
    let newPara = para;
    newPara = newPara.replace(/(^\s*)|(\s*$)/gi, '');
    newPara = newPara.replace(/[ ]{2,}/gi, ' ');
    newPara = newPara.replace(/\n /, '\n');
    return newPara.split(' ').length;
  },
  swapElement: (list, firstIndex, secondIndex) => {
    const newList = cloneDeep(list);
    const temp = newList[secondIndex];
    newList[secondIndex] = newList[firstIndex];
    newList[firstIndex] = temp;
    return newList;
  },
  getVideoElement: (url, elementId) => {
    const id = elementId || 'temp_video_for_video_duration';
    const videlem = document.createElement('video');
    const source = document.createElement('source');
    source.src = url;
    videlem.id = id;
    videlem.appendChild(source);
    return {
      element: videlem,
      id
    };
  },
  getAudioElement: (url, elementId) => {
    const id = elementId || 'temp_audio_for_audio_duration';
    const audelem = document.createElement('audio');
    const source = document.createElement('source');
    source.src = url;
    audelem.id = id;
    audelem.appendChild(source);
    return {
      element: audelem,
      id
    };
  },
  removeElementById: id => document.getElementById(id).remove(),
  isValidGoingBack: (backLocationUrl) => {
    const inProgressUploading = getObjSize(window.courseUpload);
    const isBlockProgressUloading = getObjSize(window.blockUpload);
    if (inProgressUploading > 0 || isBlockProgressUloading > 0) {
      const userAnswer = window.confirm(
        'All your current uploading document will be gone. Are you sure you want to leave this page?'
      );
      if (userAnswer) {
        window.location.href = backLocationUrl;
      }
    } else {
      window.location.href = backLocationUrl;
    }
  },
  getIcon: (type, color, size) => {
    switch (type) {
      case 'html':
        return <Icon icon="html" fill={color} size={size} viewBox="0 0 47 47" />;
      case 'video':
        return <Icon icon="video" fill={color} size={size} viewBox="0 0 37 42" />;
      case 'url':
        return <Icon icon="url" fill={color} size={size} viewBox="0 0 42 42" />;
      case 'scorm':
        return <Icon icon="scorm" fill={color} size={size} viewBox="0 0 45 39" />;
      case 'objective':
        return <Icon icon="objective" fill={color} size={size} viewBox="0 0 64 34" />;
      case 'subjective':
        return <Icon icon="subjective" fill={color} size={size} viewBox="0 0 36 44" />;
      case 'peer-graded':
        return <Icon icon="peer-graded" fill={color} size={size} viewBox="0 0 52 45" />;
      case 'blocks':
        return (
          <Icon
            icon="blocks-2"
            fill={color}
            size={size}
            viewBox="4 4 49 49"
            childProps={{ strokeWidth: '1.5', stroke: '#c0ccdb' }}
          />
        );
      default:
        return <Icon icon="html" fill={color} size={size} viewBox="0 0 47 47" />;
    }
  }
};
